{
  "unsubscribe_title": "Unsubscribe from emails",
  "unsubscribe_message": "Sorry to see you go.",
  "unsubscribe": "Unsubscribe",
  "cancel": "Cancel",
  "passwordResetSuccess": "Your password has been changed successfully.",
  "passwordResetError": "Unfortunately, there was a problem",
  "passwordResetExpired": "This link is invalid or expired. Please request a new password reset email.",
  "passwordResetTitle": "Set a new password",
  "new_password": "New password",
  "confirm_password": "Confirm new password",
  "save": "Save",
  "error": "Unfortunately, there was a problem",
  "unsubscribeSuccess": "The action was successful",
  "emailChangeLoading": "Email change loading...",
  "emailChangeSuccess": "The email was successfully changed",
  "emailChangeError": "Unfortunately, there was a problem changing the email",
  "loading": "Loading...",
  "deletionStatusError": "Error loading deletion status",
  "deletionStatusTitle": "Account Deletion Status",
  "deletionStatus": {
    "pending": "Your account deletion request is being processed",
    "Deleted": "Your account has been successfully deleted",
    "Failed to find user": "Failed to find user account",
    "Failed to check if user can be deleted": "Failed to verify deletion eligibility",
    "Failed to delete user": "Failed to complete deletion",
    "User cannot be deleted, maybe has active subscription": "Account cannot be deleted due to active subscription"
  },
  "home": {
    "tagline": "Over 1 million dog owners train with Hundeo",
    "subline": "Recommended by real dog trainers",
    "appStorePrefix": "Download on the",
    "playStorePrefix": "Get it on",
    "qrHint": "Open the app on your phone",
    "qrCaption": "Scan the code with your camera",
    "socialProof": "5,000+ 5-star reviews",
    "imprint": "Imprint",
    "privacy": "Privacy",
    "language": "Language",
    "openWebsite": "Visit website",
    "openInApp": "Open in Hundeo app",
    "openInAppHint": "You'll be taken to your app",
    "openInAppButton": "Open",
    "promoRedirectTitle": "Opening your offer …",
    "promoRedirectButton": "Continue to your offer"
  }
}
